// extracted by mini-css-extract-plugin
export default {"container":"DDvTj6heDo"};
    if(module.hot) {
      // 1643570391306
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  